import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 48px;
  column-gap: 22px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(3, 1fr);
  }
`

export const PagePair = styled.div`
  display: flex;
`
